
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export function ProfileHeader() {
  return (
    <div className="text-center mb-8">
      <Avatar className="w-24 h-24 mx-auto mb-4 ring-4 ring-white shadow-lg">
        <AvatarImage src="/placeholder.svg" alt="Dra. Brenda Ramos" />
        <AvatarFallback className="bg-white/20 text-white text-2xl font-semibold">
          BR
        </AvatarFallback>
      </Avatar>

      <h1 className="text-2xl font-bold text-white mb-2">Dra Brenda Ramos</h1>

      <p className="text-white/90 text-lg mb-2">Nutricionista CRN: 3/63492</p>

      <p className="text-white/80 max-w-sm mx-auto leading-relaxed">
        Especialista em nutrição clínica e emagrecimento saudável. Transformando vidas através da alimentação consciente.
      </p>
    </div>
  );
}
